export enum TypePatientEnum {
  ADULT = 'ADULT',
  MINOR = 'MINOR'
}
